import React from 'react';

const Home = () => (
  <div className="homepage">
    <h2>Welcome to our page!</h2>
    <div className="welcome">
      <p>Math Magicians – your gateway to seamless calculations and a touch of inspiration!</p>
      <p>With a sleek design and friendly UI, our app transforms complex math into a breeze.</p>
      <p>From basic arithmetic to an advanced feature such as modulo operations.</p>
      <p>Enjoy thought-provoking quotes for that extra motivation.</p>
      <p>Embrace your inner math magician today – let&apos;s make math fun!</p>
    </div>
  </div>
);

export default Home;
